export const MIN_READING_TIME_IN_SECONDS = 30;
